module.exports = __webpack_public_path__ + "static/media/case.d3e33059.png";